const rotateImages = () => {
  if (document.querySelector('.rotate-images')) {
    const containers = document.querySelectorAll('.rotate-images');

    const rotateImages = () => {
      containers.forEach(container => {
        const time = parseInt(container.getAttribute('data-time'));
        const images = container.querySelectorAll('img');

        let currentIndex = 0;

        const activateImage = index => {
          images.forEach((image, i) => {
            if (i === index) {
              image.classList.add('active');
            } else {
              image.classList.remove('active');
            }
          });
        };

        activateImage(currentIndex);

        setInterval(() => {
          currentIndex = (currentIndex + 1) % images.length;
          activateImage(currentIndex);
        }, time);
      });
    };

    rotateImages();
  }
};

export default rotateImages;
